/** @jsxImportSource @emotion/react */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { View } from 'react-native-web';
import { Col, Container, Row } from 'reactstrap';

import Selectors from 'Redux/Selectors';
import Actions from 'Redux/Actions';
import Button from 'Components/Button';

import Utils from 'Lib/Utils';
import LoginSignUpModal from 'Containers/User/LoginSignUpModal';
import AssistanceNumber from './Components/AssistanceNumber';

import ProductList from './Components/ProductList';
import CartBreadcrumbs from './Components/CartBreadcrumbs';
import OrderSummaryReview from './Components/OrderSummaryReview';
import OrderReviewSection from './Components/OrderReviewSection';
import GoldPriceChangeAlert from './Components/GoldPriceChangeAlert';
import NavActions from '../../Services/Navigation/Actions';
import ModalUnavailableProducts from './Components/ModalUnavailableProducts';

import { cartContainer, cartTitle } from './Styles/CartStyles';
import {
    orderReviewSection,
    orderReviewText,
    orderReviewTitle,
} from './Styles/OrderReviewStyles';

const OrderReview = (props) => {
    const { cartItems, shippingFee, shippingAddress, customerRemarks, stockCheckAndLock,
        stockCheckLoading, clearStockCheckUnavailableProducts, goldPrice,
        placeOrder, placeOrderLoading, placeOrderError, stockUnavailableVisible,
        getEGHLInfo, setEGHLInfo, getUserIP, getCartIsGuest, placeOrderGuest } = props;

    const [loginModalVisible, setLoginModalVisible] = useState(false);
    const [userIP, setUserIP] = useState(false);

    const callGetUserIP = async () => {
        const ip = await getUserIP();

        setUserIP(ip.payload);
    };

    useEffect(() => {
        callGetUserIP();
        return () => {
            clearStockCheckUnavailableProducts();
        };
    }, []);

    let total = 0;

    cartItems.forEach(item => {
        const { selectedVariant, quantity } = item;
        const variantPrice = Utils.Jemisys.getItemVariantPrice(item, selectedVariant, goldPrice);
        total += (variantPrice * quantity);
    });

    if (!cartItems.length || !shippingAddress || !shippingAddress.address1) {
        NavActions.navToCart();
    }

    // const asBilling = shippingAddress.customAttributes.find((x) => x.name === 'asBilling');

    // TODO: get discount price from promoCode
    const discountPrice = 0;

    const orderSummary = {
        shippingFee,
        subTotal: total,
        currency: 'MYR',
        promoCode: null,
        discountPrice,
        // laborCost: total.totalLaborCost,
        totalCost: total + shippingFee - discountPrice,
    };

    const onAuthorized = () => {
        setLoginModalVisible(false);
    };

    const onSignup = () => {
        setLoginModalVisible(true);
    };

    const onProceed = async () => {
        const totalPrice = total + shippingFee;
        const paymentMethod = 4; // eGHL

        stockCheckAndLock(cartItems);

        if (getCartIsGuest) {
            await placeOrderGuest(totalPrice, paymentMethod, shippingFee);
        } else {
            await placeOrder(totalPrice, paymentMethod, shippingFee);
        }

        setEGHLInfo({ ...getEGHLInfo, Amount: totalPrice.toFixed(2), CustIP: userIP });

        NavActions.navToPayment();
    };

    const renderCustomerRemarks = () => {
        if (!customerRemarks) return false;

        return (
            <OrderReviewSection
                title='Customer Remarks'
                onClick={NavActions.navToShippingAddress}
            >
                <Row css={orderReviewSection}>
                    <Col>
                        <div css={orderReviewText}>{customerRemarks}</div>
                    </Col>
                </Row>
            </OrderReviewSection>
        );
    };

    const {
        lastName, firstName, address1, address2, city, postCode, state, country, email, phoneNumber,
    } = shippingAddress;

    let addressString = address1;
    if (address2) addressString = `${addressString}, ${address2}`;

    return (
        <View>
            <Container fluid css={cartContainer}>
                <CartBreadcrumbs currentItem={2} />
                <Row>
                    <Col xs={12} xl={8}>
                        <Row>
                            <Col>
                                <div css={cartTitle}>Order Review</div>
                            </Col>
                        </Row>

                        <GoldPriceChangeAlert />
                        <ProductList products={cartItems} />
                        <OrderReviewSection
                            title='Shipping Address'
                            onClick={NavActions.navToShippingAddress}
                        >
                            <Row>
                                <Col xs='3' style={{ marginTop: 40, marginBottom: 24 }}>
                                    <div css={orderReviewTitle}>Full name</div>
                                    <div css={orderReviewText}>{`${firstName} ${lastName}`}</div>
                                </Col>
                                <Col style={{ marginTop: 40, marginBottom: 24 }}>
                                    <div css={orderReviewTitle}>Email address</div>
                                    <div css={orderReviewText}>{email}</div>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs='3' style={{ marginBottom: 40 }}>
                                    <div css={orderReviewTitle}>Phone number</div>
                                    <div css={orderReviewText}>
                                        {phoneNumber}
                                    </div>
                                </Col>
                                <Col style={{ marginBottom: 40 }}>
                                    <div css={orderReviewTitle}>Shipping address</div>
                                    <div css={orderReviewText}>
                                        {` ${addressString}, ${city}, ${postCode}, ${state}, ${country}.`}
                                    </div>

                                </Col>
                            </Row>
                            {
                                placeOrderError && (
                                    <Row>
                                        <Col>
                                            <div style={{ color: 'red' }}>{placeOrderError}</div>
                                        </Col>
                                    </Row>
                                )
                            }
                            <Button loading={placeOrderLoading} onClick={onProceed} text='Continue' rightArrow />
                        </OrderReviewSection>

                        {renderCustomerRemarks()}
                    </Col>
                    <Col xs={12} xl={4}>
                        <OrderSummaryReview data={orderSummary} />
                        <AssistanceNumber mobileNumber='+60 16-773 0338 ' />
                    </Col>
                </Row>
            </Container>

            <ModalUnavailableProducts isOpen={stockUnavailableVisible} />
            <LoginSignUpModal
                show={() => setLoginModalVisible(true)}
                hide={() => setLoginModalVisible(false)}
                modal={loginModalVisible}
                onAuthorized={onAuthorized}
                onSignup={onSignup}
            />
        </View>
    );
};

const mapStateToProps = (state) => ({
    cartItems: Selectors.getCartItems(state),
    userInfo: Selectors.getUserInfo(state),
    goldPrice: Selectors.getHomeGoldPrice(state),
    customerRemarks: Selectors.getCartCustomerRemarks(state),
    shippingFee: Selectors.getCartShippingFee(state),
    shippingAddress: Selectors.getCartShippingAddress(state),
    stockCheckLoading: Selectors.getUiStockCheckAttempting(state),
    stockCheckError: Selectors.getUiStockCheckError(state),
    placeOrderLoading: Selectors.getCartPlaceOrderAttempting(state),
    placeOrderError: Selectors.getCartPlaceOrderError(state),
    stockUnavailableVisible: Selectors.getUiCartStockUnavailableVisible(state),
    isLoggedIn: Selectors.getAuthAuthToken(state),
    getEGHLInfo: Selectors.getCartEGHLInfo(state),
    getCartIsGuest: Selectors.getCartIsGuest(state),
});

const mapDispatchToProps = (dispatch) => ({
    stockCheckAndLock: (products) => dispatch(Actions.uiStockCheckAndLock({ products })),
    clearStockCheckUnavailableProducts: () => dispatch(Actions.uiClearStockCheckUnavailableProducts()),
    placeOrder: (totalPrice, paymentMethod, shippingFee) => dispatch(Actions.cartPlaceOrder({ totalPrice, paymentMethod, shippingFee })),
    placeOrderGuest: (totalPrice, paymentMethod, shippingFee) => dispatch(Actions.cartPlaceOrderGuest({ totalPrice, paymentMethod, shippingFee })),
    setEGHLInfo: (info) => dispatch(Actions.cartSetEGHLInfo(info)),
    getUserIP: () => dispatch(Actions.userGetUserIP()),
});

export default connect(mapStateToProps, mapDispatchToProps)(OrderReview);
